module.exports = __webpack_public_path__ + "static/img/user.ff22a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 8tHC
// module chunks = 1